import { NavMarker } from 'react-rhumb';
import PreviewBox from './PreviewBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { useScreenSize } from '../hooks/useScreenSize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StepLayout({
  step,
  i18nKey,
  children,
  chatOnly = true
}) {
  const isSmallScreen = useScreenSize();
  const columnProps = isSmallScreen ? {
    inlineSize: '100%',
    paddingInlineEnd: '0'
  } : {};
  return /*#__PURE__*/_jsx(NavMarker, {
    name: `STEP_${step}`,
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: isSmallScreen ? 'column' : 'row',
      children: [/*#__PURE__*/_jsx(View, Object.assign({
        inlineSize: "35%",
        paddingInlineEnd: "1100"
      }, columnProps, {
        children: /*#__PURE__*/_jsxs(View, {
          paddingBlock: "600",
          paddingInlineStart: "200",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h1",
            marginBlockEnd: "800",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `app.${i18nKey}.dayMode.title`
            })
          }), children]
        })
      })), /*#__PURE__*/_jsx(Flex, Object.assign({
        inlineSize: "65%",
        justifyContent: "center"
      }, columnProps, {
        children: /*#__PURE__*/_jsx(View, {
          paddingInlineEnd: "200",
          inlineSize: "100%",
          children: /*#__PURE__*/_jsx(PreviewBox, {
            chatOnly: chatOnly
          })
        })
      }))]
    })
  });
}